import $ from 'jquery';

var Radio = {
    selectors: {
        radio: $('.radio-input'),
        radio_labels: $('.radio-labels')
    },

    init: function () {
        this.radioChangeHandler();
    },

    radioChangeHandler: function () {
        var selectors = this.selectors;

        selectors.radio.each(function () {
            $(this).change(function() {
                $(this).parents('.radio-labels').find('.radio-label').removeClass('radio-checked');
                $(this).parents('.radio-label').addClass('radio-checked');
            })
        })
    }
}

export default Radio;
